import React from 'react'
import { useLocation } from 'react-router-dom'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'

import AuthorAndDate from './AuthorAndDate'
import CommentBody from './CommentBody'

import styles from './CommentThread.module.sass'
import { useDrawerContext } from 'context/Drawer/DrawerContext'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { useReload } from 'store'

const CommentReply = ({ reply }) => {
	const {
		body,
		author,
		date,
		isInternalNote,
		hasFiles,
		files,
		providerEstablishment,
		notifiedEstablishments = [],
		notifiedEntities = [],
	} = reply

	const { i18n, openFile, showDialog } = useGlobal()
	const location = useLocation()
	const reload = useReload()
	const [queryParams, , setSearchParams] = useQueryParams(location)
	const { dispatch } = useDrawerContext()

	const commentOptions = [
		{
			value: 'add-comment-to-thread',
			text: i18n`Associate with another comment`,
			action: () => {
				showDialog(
					'AddCommentToThread',
					i18n`Associate with another comment`,
					{
						processId: reply.processId,
						commentId: reply.id,
						parentId: queryParams.comment,
					},
					false,
					undefined,
					'center',
					'add-comment-to-thread-dialog'
				)
					.then((parent) => {
						reload([
							`/clinical_processes/${reply?.processId}/comments`,
							`/clinical_processes/${reply?.processId}/comments/${reply.id}`,
							`/clinical_processes/${reply?.processId}/comments/${reply.id}/replies`,
							`/clinical_processes/${reply?.processId}/comments/${parent}/replies`,
						])
						setSearchParams({ comment: parent })
						dispatch({
							action: 'OPEN_DRAWER',
							payload: {
								data: {
									processId: reply.processId,
									id: parent,
								},
								type: 'CommentThreadDrawer',
							},
						})
					})
					.catch(() => null)
			},
		},
		{
			value: 'create-thread-from-comment',
			text: i18n`Unlink from thread`,
			action: () => {
				showDialog(
					'CreateThreadFromComment',
					i18n`Unlink from thread`,
					{
						processId: reply.processId,
						commentId: reply.id,
					},
					false,
					undefined,
					'center',
					'create-thread-from-comment-dialog'
				)
					.then(() => {
						reload([
							`/clinical_processes/${reply.processId}/comments`,
							`/clinical_processes/${reply.processId}/comments/${reply.id}`,
							`/clinical_processes/${reply.processId}/comments/${reply.id}/replies`,
							`/clinical_processes/${reply.processId}/comments/${queryParams.comment}/replies`,
						])
						setSearchParams({ comment: reply.id })
						dispatch({
							action: 'OPEN_DRAWER',
							payload: {
								data: {
									processId: reply.processId,
									id: reply.id,
								},
								type: 'CommentThreadDrawer',
							},
						})
					})
					.catch(() => null)
			},
		},
	]

	return (
		<div
			className={`${styles['list-item-entry']}
				${isInternalNote ? styles['internal-note'] : styles['horizontal-padding']}
			`}
		>
			<div
				className={`${styles['author-indentation']} ${
					isInternalNote ? styles['horizontal-padding'] : ''
				}`}
			>
				<AuthorAndDate
					author={isInternalNote ? { name: i18n`Note` } : author}
					date={date.dateTimeFormat}
					providerEstablishment={
						isInternalNote ? undefined : providerEstablishment
					}
					className={styles['comment-reply-avatar']}
					padded
					notifiedEntities={notifiedEntities}
					notifiedEstablishments={notifiedEstablishments}
				/>
				{!isInternalNote && (
					<ModalOptions
						options={commentOptions}
						onSelect={(item) => {
							item && item.action && item.action()
						}}
					>
						<button
							className={`${styles['comment-reply-options']} ${
								hasFiles ? styles['--with-files'] : ''
							}`}
						>
							<Icon
								className={styles['more-icon']}
								width='32px'
								height='32px'
								name='more'
							/>
						</button>
					</ModalOptions>
				)}
			</div>
			<div
				className={`${styles['body-indentation']} ${
					isInternalNote ? styles['horizontal-padding'] : ''
				}`}
			>
				<CommentBody body={body} padded />
			</div>
			{hasFiles && (
				<ModalOptions
					title={i18n`Documents`}
					options={files}
					centerArrow
					fixedHeight='auto'
					alwaysAbove
					selectable={false}
					onSelect={(e) => {
						openFile && openFile(e)
						return true
					}}
				>
					<Icon
						className={styles['attachments-reply']}
						name='attachment'
					/>
				</ModalOptions>
			)}
		</div>
	)
}

export default CommentReply
